import { fetchFromApi } from './fetchFromApi';
import { isAborted } from './methods/isAborted';

export const fetchTags = (prefix: string, signal?: AbortSignal) => {
  return fetchFromApi<string[]>('tags', { prefix, simple: true }, { signal }).catch((e) => {
    if (isAborted(e)) {
      return null;
    }
    throw e;
  });
};
